import { SET_PRODUCTION_SCHEDULES } from "../actions/productionSchedulesAction"

let initialState = {
   productionSchedules: [],
}

export default (state = initialState, action) => {
   switch (action.type) {
      case SET_PRODUCTION_SCHEDULES:
         return { productionSchedules: action.payload }
      default:
         return state
   }
}
